import React, { Fragment } from 'react';
import {
	ExperienceSuccessTracker as ViewExperienceSuccessTracker,
	type TrackerWithoutCallbacksProps,
} from '@atlassian/jira-common-experience-tracking-viewing/src/view/experience-tracker-consumer/result-declared/index.tsx';
import { ExperienceSuccess } from '@atlassian/jira-experience-tracker/src/ui/experience-success/index.tsx';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { getWillShowNav3 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav3.tsx';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import { EXPERIENCE_NAVIGATION_TOP_MAIN } from '../../common/constants.tsx';
import type { NavigationSuccessTrackerProps } from './types.tsx';

const EmptyFragment = ({ children }: TrackerWithoutCallbacksProps) => <>{children}</>;

const NavigationSuccessTracker = ({ children }: NavigationSuccessTrackerProps) => {
	const route = useCurrentRoute();

	const ViewExperienceSuccessTrackerComponent =
		route.isRedirect === true ? EmptyFragment : ViewExperienceSuccessTracker;

	return (
		<ViewExperienceSuccessTrackerComponent
			location="atlassian-navigation-main"
			parentProviders={null}
			failureEventAttributes={null}
		>
			{children}
			<ExperienceSuccess experience={EXPERIENCE_NAVIGATION_TOP_MAIN} />
		</ViewExperienceSuccessTrackerComponent>
	);
};

export const NavigationSuccessTrackerForNav3 = componentWithCondition(
	getWillShowNav3,
	NavigationSuccessTracker,
	Fragment,
);
